import React, {forwardRef, useState, useMemo, ForwardRefRenderFunction, useCallback} from 'react';
import {toast, Upload, Button, Alert} from 'acud';
import HooksForm from '../../../../components/biz/HooksForm';
import useForm from '../../../../hooks/biz/form';
import {OutlinedButtonUpload} from 'acud-icon';
const controls = (props: any, _, customFunctions: any) => {
    const {fileList = [], typeOptions, uploagConfig = {}, extraMsg = ''} = props || {};
    const config = {
        name: 'file',
        accept: '.xls,.xlsx',
        multiple: false,
        maxCount: 1,
        ...uploagConfig,
        fileList,
        beforeUpload: async (file: any) => {
            const {name} = file;
            if (uploagConfig?.beforeUpload) {
                uploagConfig?.beforeUpload(file, () => {
                    customFunctions.setFileInfo(file, name);
                });
            }
            else {
                customFunctions.setFileInfo(file, name);
            }
        },
        onRemove: (file: any) => {
            if (uploagConfig?.onRemove) {
                uploagConfig?.onRemove(file, () => {
                    customFunctions.setFileInfo(null, null);
                });
            }
            else {
                customFunctions.setFileInfo(null, null);
            }
        }
    };
    return [
        {
            type: 'radio',
            name: 'type',
            label: '导入模式',
            defaultValue: typeOptions?.[0]?.value || 'new',
            config: {
                options: typeOptions || [{label: '新增数据', value: 'new'}, {label: '更新数据', value: 'update'}]
            },
            rules: [{required: true, message: '请选择导入模式'}]
        },
        {
            type: 'custom',
            name: 'upload',
            label: '文件',
            content: (
                <Upload {...config}>
                    <Button
                        icon={<OutlinedButtonUpload />}
                        style={{pointerEvents: 'none'}}
                        type="primary"
                    >
                        上传文件
                    </Button>
                </Upload>
            ),
            rules: [
                {required: true, message: '请选择上传文件'},
                {
                    validator: (_: any, value: any, callback) => {
                        if (value?.file?.status !== 'uploading') {
                            callback(
                                <div>
                                    请选择上传文件
                                    {extraMsg && <div style={{color: '#84868C'}}>{extraMsg}</div>}
                                </div>
                            );
                        }
                        callback();
                    }
                }
            ],
            ...(extraMsg ? {extra: extraMsg} : {})
        }
    ];
};

interface TagFormProps {
    payload: {
        actions: Record<string, any>;
        alterMsg?: string | React.ReactNode;
        typeOptions?: {label: string; value: string}[];
        uploagConfig: Record<string, any>;
        extraMsg?: string | React.ReactNode;
    }
}
const UploadForm: ForwardRefRenderFunction<unknown, TagFormProps> = (props, ref) => {
    const {payload} = props;
    const [fileList, setFileList] = useState<{name: string}[]>([]);

    const actionConfig = useMemo(() => {
        return {
            submitAction: {
                submitFormAction: 'upload',
                $onSubmitRequest(formDataInfo: any) {
                    return {...formDataInfo};
                },
                $onSubmitResponse(res: any) {
                    if (res.success === false) {
                        toast.error({
                            message: res.data.err || '上传失败',
                            duration: 5
                        });
                        throw Error(res.data.err || '上传失败');
                    }
                }
            }
        };
    }, []);

    const setFileInfo = useCallback((file: any, name: string) => {
        if (form) {
            if (name) {
                form?.setFieldsValue({upload: file});
                setFileList([{name}]);
            }
            else {
                form?.setFieldsValue({upload: undefined});
                setFileList([]);
            }
        }
    }, []);

    const customFunctions = useMemo(() => ({setFileInfo}), [setFileInfo]);

    const options = useMemo(() => ({
        controls,
        formItemOption: {
            noStyle: true
        },
        actionConfig,
        customFunctions
    }), [actionConfig, customFunctions]);

    const {form, formProps} = useForm(ref, {...payload, fileList}, options as any);

    return (
        <HooksForm
            {...(payload.alterMsg ? {description: <Alert message={payload?.alterMsg} type="info" />} : {})}
            {...formProps}
            form={form}
        />
    );
};

export default forwardRef(UploadForm);
